module.exports = __webpack_public_path__ + "static/media/button-selected-none.f340d4ec.svg";